import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '@core/services/storage.service';
import { GLOBAL_CONSTANTS } from '@core/models/global.constants';
import { type IUser } from '@core/models/user.interface';

/**
 * Interceptor to add Correlation-ID and Tenant-ID headers.
 * Follows minions-ui HttpCorrelationIdInterceptor pattern.
 */
export const httpCorrelationInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const correlationId = crypto.randomUUID();

  const setHeaders: Record<string, string> = {
    'correlation-id': correlationId,
  };

  const userJson = storageService.getCookieByName(GLOBAL_CONSTANTS.userCookieName);
  if (userJson) {
    try {
      const user = JSON.parse(userJson) as IUser;
      if (user?.tenant) {
        setHeaders['tenantId'] = user.tenant;
      }
    } catch {
      // Silently fail if cookie is malformed
    }
  }

  const modifiedReq = req.clone({ setHeaders });

  return next(modifiedReq);
};
